import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';

type Props = {
  title: string;
  children: any;
};

const ReportContainer: React.FC<Props> = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.grid}>
      <Typography className={classes.title}>{props.title}</Typography>
      {props.children}
    </Box>
  );
};

export default ReportContainer;

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(24),
    lineHeight: theme.typography.pxToRem(36),
    fontFamily: FONT_GSS_FUTURA_BOLD,
    marginBottom: remCalc(24),
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    width: '100%',
    gridGap: theme.typography.pxToRem(2),
  },
}));
